import { useEffect, useState } from 'react'
import useFamilyTreeData from '../../../../shared/hooks/useFamilyTreeData'

const GROUP_TYPES = [
  {
    regex: /^[1]$/,
    nameTranslationKey: 'aam.year-picker.my-years',
    index: 0,
  },
  {
    regex: /1\.|1-S/,
    nameTranslationKey: 'aam.year-picker.my-family',
    index: 1,
  },
  {
    regex: /^[2-3]$/,
    nameTranslationKey: 'aam.year-picker.my-parents',
    index: 2,
  },
  {
    regex: /^[4-7]$/,
    nameTranslationKey: 'aam.year-picker.my-grandparents',
    index: 3,
  },
  {
    regex: /^[8-9]|(1[0-5]$)/,
    nameTranslationKey: 'aam.year-picker.my-great-grandparents',
    index: 4,
  },
]

export default function useYearPickerGenerations() {
  const [ancestorBirthGroups, setAncestorBirthGroups] = useState([])
  const [treeDataState] = useFamilyTreeData(3)

  useEffect(() => {
    // give local state control for active state
    if (treeDataState.complete) {
      const generations = createGenerations(treeDataState.res)
      setAncestorBirthGroups(generations)
    }
  }, [treeDataState])

  return ancestorBirthGroups
}

// Note from Polymer ds-select-by-year:
// We don't want to have the possibility of ending up with empty arrays in the accumulator, so we'll only create them
// if we need them
function addToAccumulatorSubArray(accumulator, person, nameTranslationKey, index) {
  while (!accumulator[index]) {
    accumulator.push({})
  }

  if (accumulator[index].nameTranslationKey !== nameTranslationKey) {
    accumulator[index].nameTranslationKey = nameTranslationKey
  }

  if (!Array.isArray(accumulator[index].people)) {
    accumulator[index].people = []
  }

  accumulator[index].people.push(person)
}

function reduceGenerations(accumulator, person) {
  const atn = person.atn

  person.displayName = `${person.name} ${person.surname}`

  if (person.gender) {
    person.gender = person.gender.toLowerCase()
  }

  const groupType = GROUP_TYPES.find((type) => type.regex.test(atn))

  if (groupType) {
    const { nameTranslationKey, index } = groupType
    addToAccumulatorSubArray(accumulator, { ...person }, nameTranslationKey, index)
  }

  return accumulator
}

function createGenerations(people) {
  return people.reduce(reduceGenerations, [])
}
